query GetAccountDids(
  $id: ID!
  $first: Int
  $last: Int
  $after: String
  $before: String
  $query: String
  $queryList: [QueryItemInput!]
) {
  didsForAccount(
    accountId: $id
    first: $first
    last: $last
    after: $after
    before: $before
    query: $query
    queryList: $queryList
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    edges {
      node {
        id
        number
        insertedAt
        updatedAt
        account {
          id
          name
        }
        autoResponse {
          id
          insertedAt
          updatedAt
          name
          notes
          keywords {
            id
            message
            keyword
            isWildcard
            intercept
          }
        }
      }
    }
  }
}
